/** Stable `getRowItem` for `useRowChatDrag` when a row is its own chat item. */
export const identity = <T>(value: T): T => value;
